import React from 'react'

function MobileWebColor({ height, width }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 492.035 300">
      <defs>
        <filter id="Rectangle_993" width="259.324" height="162.077" x="127.143" y="98.372" filterUnits="userSpaceOnUse">
          <feOffset dx="7" />
          <feGaussianBlur result="blur" />
          <feFlood floodColor="#fff" floodOpacity="0.161" result="color" />
          <feComposite in="SourceGraphic" in2="blur" operator="out" />
          <feComposite in="color" operator="in" />
          <feComposite in2="SourceGraphic" operator="in" />
        </filter>
        <filter id="Rectangle_1004" width="57.661" height="101.683" x="91.108" y="197.967" filterUnits="userSpaceOnUse">
          <feOffset dx="4" />
          <feGaussianBlur result="blur-2" />
          <feFlood floodColor="#fff" floodOpacity="0.271" result="color-2" />
          <feComposite in="SourceGraphic" in2="blur-2" operator="out" />
          <feComposite in="color-2" operator="in" />
          <feComposite in2="SourceGraphic" operator="in" />
        </filter>
        <filter id="Rectangle_1047">
          <feOffset dx="4" />
          <feGaussianBlur result="blur-3" />
          <feFlood floodColor="#fff" floodOpacity="0.161" result="color-3" />
          <feComposite in="SourceGraphic" in2="blur-3" operator="out" />
          <feComposite in="color-3" operator="in" />
          <feComposite in2="SourceGraphic" operator="in" />
        </filter>
        <clipPath id="clip">
          <use xlinkHref="#fill" />
        </clipPath>
      </defs>
      <g data-name="Group 5813" transform="translate(-138.476 -1690.436)">
        <g data-name="Group 5789" transform="translate(138.476 1690.436)">
          <circle
            cx="105.051"
            cy="105.051"
            r="105.051"
            fill="rgba(33,71,150,0.06)"
            data-name="Ellipse 482"
            transform="translate(83.837)"
          />
          <path
            fill="#24397a"
            fillRule="evenodd"
            d="M198.768 285.615a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.153-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.153-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.152-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.152-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.152-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.151-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.151-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.15-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.15-2.153zm-15.068 0A2.153 2.153 0 1161 287.768a2.153 2.153 0 012.153-2.153zm135.615-15.068a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.15-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.15-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.149-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.149-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.149-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.148-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.148-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.147-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.147-2.153zm-15.068 0A2.153 2.153 0 1161 272.7a2.153 2.153 0 012.153-2.153zm135.615-15.068a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.147-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.147-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.146-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.146-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.146-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.145-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.145-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.144-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.144-2.153zm-15.068 0A2.153 2.153 0 1161 257.631a2.153 2.153 0 012.153-2.152zm135.606-15.069a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.153-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.153-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.152-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.152-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.152-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.151-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.151-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.15-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.15-2.153zm-15.068 0A2.153 2.153 0 1161 242.563a2.153 2.153 0 012.153-2.153zm135.615-15.068a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.15-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.15-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.149-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.149-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.149-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.148-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.148-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.147-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.147-2.153zm-15.068 0A2.153 2.153 0 1161 227.495a2.153 2.153 0 012.153-2.153zm135.615-15.068a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.147-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.147-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.146-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.146-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.146-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.145-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.145-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.144-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.144-2.153zm-15.068 0A2.153 2.153 0 1161 212.426a2.153 2.153 0 012.153-2.152zm135.615-15.068a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.144-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.144-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.143-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.143-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.143-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.142-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.142-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.141-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.141-2.154zm-15.068 0A2.153 2.153 0 1161 197.358a2.153 2.153 0 012.153-2.153zm135.615-15.068a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.141-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.141-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.14-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.14-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.14-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.139-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.139-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.138-2.154zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.138-2.154zm-15.068 0A2.153 2.153 0 1161 182.289a2.153 2.153 0 012.153-2.152zm135.615-15.068a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.138-2.155zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.138-2.155zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.137-2.155zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.137-2.155zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.137-2.155zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.136-2.155zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.136-2.155zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.135-2.155zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.135-2.155zm-15.068 0A2.153 2.153 0 1161 167.221a2.153 2.153 0 012.153-2.153zM198.768 150a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.153-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153A2.153 2.153 0 01183.7 150zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.152-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.152-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.152-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.151-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.151-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.15-2.153zm-15.068 0a2.153 2.153 0 11-2.153 2.153 2.153 2.153 0 012.15-2.153zm-15.068 0A2.153 2.153 0 1161 152.153 2.153 2.153 0 0163.153 150z"
            opacity="0.2"
            transform="translate(-19.554 -138.352)"
          />
          <g data-name="Group 2559" transform="translate(0 75.755)">
            <circle
              cx="28.449"
              cy="28.449"
              r="28.449"
              fill="rgba(33,71,150,0.06)"
              data-name="Ellipse 75"
              transform="translate(366.117)"
            />
            <g data-name="Group 2556" transform="translate(391.245 135.796)">
              <g data-name="Group 2553">
                <g data-name="Group 941">
                  <g data-name="Group 822">
                    <g>
                      <path fill="none" d="M0 0h68.1v68.1H0z" data-name="Path 395" />
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g data-name="Group 1361" transform="translate(0 22.618)">
              <g data-name="Group 872">
                <rect
                  width="12.571"
                  height="34.568"
                  fill="#2b2884"
                  data-name="Rectangle 1001"
                  rx="4"
                  transform="translate(250.87 154.724)"
                />
                <g data-type="innerShadowGroup">
                  <rect
                    width="162.077"
                    height="259.324"
                    fill="#514ea2"
                    data-name="Rectangle 993"
                    rx="8"
                    transform="rotate(90 193.233 193.234)"
                  />
                  <g filter="url(#Rectangle_993)" transform="translate(0 -98.37)">
                    <rect
                      width="162.077"
                      height="259.324"
                      fill="#fff"
                      data-name="Rectangle 993"
                      rx="8"
                      transform="rotate(90 144.05 242.42)"
                    />
                  </g>
                </g>
                <g
                  fill="none"
                  stroke="#24397a"
                  strokeWidth="4"
                  data-name="Rectangle 995"
                  opacity="0.1"
                  transform="rotate(90 107.489 306.588)">
                  <rect id="fill" width="2.529" height="414.077" stroke="none" rx="1.264" />
                  <path d="M0 2h2.529M2 0v414.077m.529-2H0m.529 2V0" clipPath="url(#clip)" />
                </g>
                <g
                  fill="none"
                  stroke="#24397a"
                  strokeWidth="2"
                  data-name="Rectangle 1003"
                  opacity="0.1"
                  transform="rotate(90 121.997 321.097)">
                  <rect width="2.529" height="27.904" stroke="none" rx="1.264" />
                  <rect width="0.529" height="25.904" x="1" y="1" rx="0.264" />
                </g>
                <g
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeWidth="2"
                  data-name="Group 2569"
                  transform="translate(216.777 54.209)">
                  <path d="M0 0L0 22.486" data-name="Line 20" transform="translate(0 53.907)" />
                  <path
                    d="M34.417 33.724L34.001 76.4zm16.192-8.97l.392 51.646zM17.601 44.936l-.6 31.464zM68.377 0l-.949 76.331z"
                    data-name="Union 12"
                  />
                </g>
                <circle
                  cx="12.894"
                  cy="12.894"
                  r="12.894"
                  fill="rgba(33,71,150,0.06)"
                  data-name="Ellipse 78"
                  transform="translate(91.343 151.898)"
                />
                <g data-name="Group 2565" transform="translate(90.753 99.595)">
                  <rect width="57.661" height="97.89" fill="#fff" data-name="Rectangle 302" rx="4" />
                  <g data-type="innerShadowGroup">
                    <rect
                      width="57.661"
                      height="101.683"
                      fill="#00a8b6"
                      data-name="Rectangle 1004"
                      rx="4"
                      transform="translate(.356)"
                    />
                    <g filter="url(#Rectangle_1004)" transform="translate(-90.75 -197.97)">
                      <rect
                        width="57.661"
                        height="101.683"
                        fill="#fff"
                        data-name="Rectangle 1004"
                        rx="4"
                        transform="translate(91.11 197.97)"
                      />
                    </g>
                  </g>
                  <rect
                    width="10.115"
                    height="10.115"
                    fill="rgba(255,255,255,0.56)"
                    data-name="Rectangle 1005"
                    rx="5"
                    transform="translate(24.378 74.6)"
                  />
                  <text
                    fill="#fff"
                    data-name=""
                    fontFamily="JioMoney"
                    fontSize="32"
                    transform="translate(14.108 48.864)">
                    <tspan x="0" y="0">
                      
                    </tspan>
                  </text>
                </g>
                <g data-type="innerShadowGroup">
                  <path
                    fill="#514ea2"
                    d="M8 0h105.093a8 8 0 018 8v7.7H0V8a8 8 0 018-8z"
                    data-name="Rectangle 1047"
                    transform="translate(197.227 185.535)"
                  />
                  <g filter="url(#Rectangle_1047)" transform="translate(0 -98.37)">
                    <path
                      fill="#fff"
                      d="M8 0h105.093a8 8 0 018 8v7.7H0V8a8 8 0 018-8z"
                      data-name="Rectangle 1047"
                      transform="translate(197.23 283.91)"
                    />
                  </g>
                </g>
                <path
                  fill="none"
                  stroke="#fff"
                  strokeWidth="2"
                  d="M209.236 80.781s24.546 1.519 40.872-8.7 24.431-32.189 24.431-32.189"
                  data-name="Path 2007"
                />
                <path
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeWidth="2"
                  d="M265.935 42.526l9.878-3.5 1.652 9.971"
                  data-name="Path 2008"
                />
              </g>
            </g>
          </g>
        </g>
        <g data-name="Group 5735" transform="translate(433.932 1752.736)">
          <rect width="196.579" height="62.789" fill="#ffe9c6" data-name="Rectangle 2021" rx="31.394" />
          <text
            fill="#24397a"
            data-name="MyBusiness@jiopay"
            fontFamily="JioType-Bold, JioType"
            fontSize="15"
            fontWeight="700"
            opacity="0.9"
            transform="translate(23.546 36.425)">
            <tspan x="0" y="0">
              MyBusiness@jiopay
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  )
}

export default MobileWebColor
